export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/resources/components.js